import { useEffect, useState } from "react";

import { generatePath } from "react-router-dom";

import Container from "@/components/Container";
import Layout from "@/containers/Layout";
import { MaxAlertLimitReached } from "@/containers/MaxAlertLimitReached";
// Component to render preview of mentions. Should ideally be a child component
// of QueryBuilder but moved outside for performance reasons (for now at least)
import PreviewMentionList from "@/containers/QueryBuilder/PreviewMentionList";
import QueryBuilder, {
  LoadedSearchSubscription,
  PreviewMeta,
} from "@/containers/QueryBuilder/QueryBuilder";
import { useOrganization } from "@/hooks/useOrganization";
import { ROUTES } from "@/routes_new";
import AllEarsTitle from "@components/AllEarsTitle";
import Rhythm from "@components/Rhythm";
import Typography from "@components/Typography";
import { Episode } from "@/types/Episode";
import { useLingui } from "@lingui/react/macro";

export const CreateAlertView = () => {
  const { t } = useLingui();
  const [subscriptions, setSubscriptions] = useState<
    LoadedSearchSubscription[]
  >([]);
  const [previewMentions, setPreviewMentions] = useState<Episode[]>([]);
  const [previewMetaResults, setPreviewMetaResults] =
    useState<PreviewMeta | null>();

  const { data: orgData } = useOrganization();
  const organization = orgData?.ok ? orgData.data : null;

  useEffect(() => {
    if (!organization) return;
    const users = organization?.users;
    const mappedSubscriptions = users.map(({ id, name: full_name, email }) => ({
      email,
      full_name,
      id,
      interval: "none" as const,
    }));
    setSubscriptions(mappedSubscriptions);
  }, [organization]);

  const onSave = ({ uuid }: { uuid: string }) => {
    if (!organization) return;
    window.location.href = generatePath(ROUTES.MENTION_DETAIL_ORGID, {
      uuid,
      orgUuid: organization.uuid,
    });
  };

  return (
    <>
      <AllEarsTitle title={t`Skapa ny bevakning`} />
      <Layout>
        <Container center={false}>
          <Rhythm>
            <Typography variant="h1" wordBreak>
              {t`Skapa ny bevakning`}
            </Typography>
          </Rhythm>
          <QueryBuilder
            initializeEmptyForm={true}
            onSave={onSave}
            subscriptions={subscriptions}
            setPreviewMetaResults={setPreviewMetaResults}
            setPreviewMentions={setPreviewMentions}
          />

          {previewMetaResults && (
            <PreviewMentionList
              meta={previewMetaResults}
              mentions={previewMentions}
            />
          )}
        </Container>
        <MaxAlertLimitReached />
      </Layout>
    </>
  );
};
